__turbopack_context__.v({
  "body": "FlexibleDatesPanel-module__20QfQa__body",
  "buttonContainer": "FlexibleDatesPanel-module__20QfQa__buttonContainer",
  "checkboxContainer": "FlexibleDatesPanel-module__20QfQa__checkboxContainer",
  "content": "FlexibleDatesPanel-module__20QfQa__content",
  "desktopOnly": "FlexibleDatesPanel-module__20QfQa__desktopOnly",
  "dividerContainer": "FlexibleDatesPanel-module__20QfQa__dividerContainer",
  "error": "FlexibleDatesPanel-module__20QfQa__error",
  "errorsContainer": "FlexibleDatesPanel-module__20QfQa__errorsContainer",
  "footer": "FlexibleDatesPanel-module__20QfQa__footer",
  "heading": "FlexibleDatesPanel-module__20QfQa__heading",
  "mobileOnly": "FlexibleDatesPanel-module__20QfQa__mobileOnly",
  "nightsWarning": "FlexibleDatesPanel-module__20QfQa__nightsWarning",
  "tabbedContent": "FlexibleDatesPanel-module__20QfQa__tabbedContent",
  "tabsList": "FlexibleDatesPanel-module__20QfQa__tabsList",
  "valueLabel": "FlexibleDatesPanel-module__20QfQa__valueLabel",
  "warning": "FlexibleDatesPanel-module__20QfQa__warning",
  "warningSubtitle": "FlexibleDatesPanel-module__20QfQa__warningSubtitle",
});
